import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.from";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.slice";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.set";
import "core-js/modules/es.string.iterator";
import "core-js/modules/es.string.replace";
import "core-js/modules/es.string.split";
import "core-js/modules/web.dom-collections.for-each";
import "core-js/modules/web.dom-collections.iterator";
import _toConsumableArray from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _createForOfIteratorHelper from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
import { serchSelect, tabulation, gmToolNewPage, gmTool } from "@/mixins/index";
import { rechargeProducPenetrationRateCurrency, rechargeProducPenetrationRate } from "@/api/dataAll/userSegmentationGrowth";
import { serverList } from "@/api/gmtool/packageCode";
import { serverList as hdServerList } from "@/api/gmtool/packageCode";
import { serverList as yjServerList } from "@/api/gmToolNew/gmToolNew";
import * as XLSX from 'xlsx';
export default {
  name: "newUserPaid",
  mixins: [serchSelect, tabulation, gmToolNewPage, gmTool],
  data: function data() {
    return {
      tableData: [],
      deviceList: [{
        label: this.$t('newAccountLabel'),
        id: "user"
      }],
      paramsData: {
        dimension_kind: "user",
        penetration: 3
      },
      tableList: [],
      serverList: [],
      levelList: [],
      exportdataDealoading: false,
      // 新增：存储过滤后的关键数据
      validDates: [],
      // 有数据的日期（至少一个层级user_count>0）
      validLevels: [],
      // 有数据的层级（至少一个有效日期user_count>0）
      validPurchaseTimes: [],
      // 有数据的购买次数（至少一个有效日期+层级total>0）
      dateOrderProductIdArr: {} // 存储后端返回的商品ID排序

    };
  },
  computed: _objectSpread({}, mapState("d2admin", {
    severlist: function severlist(state) {
      return state.user.GMauthority;
    }
  })),
  created: function created() {
    this.searchData.env_id = this.szgmEnv.length ? this.szgmEnv[0].id : '';

    if (this.rawData.game_mark.indexOf('yjfm') == -1) {
      this.getServer();
    }
  },
  methods: {
    levelChange: function levelChange(e) {
      if (!e) {
        this.paramsData.recharge_levels = '';
      }
    },
    getServer: function getServer() {
      var _this = this;

      this.paramsData.server_id = '';
      serverList({
        is_prod: this.paramsData.is_prod,
        page_size: ''
      }).then(function (res) {
        if (res.status == 200) {
          _this.serverList = res.data;
        }
      });
    },
    searchClick: function searchClick() {
      var _this2 = this;

      // 重置所有数据
      this.tableList = [];
      this.tableData = [];
      this.validDates = [];
      this.validLevels = [];
      this.validPurchaseTimes = [];
      this.dateOrderProductIdArr = {};

      if (this.value2.length > 0) {
        this.searchData.starttime = this.value2[0];
        this.searchData.endtime = this.value2[1];
      } // 基础校验


      if (!this.paramsData.dimension_kind) {
        this.$message.error(this.$t('pleaseSelectNewDeviceOrAccount'));
        return;
      }

      if (this.levelItem == '1' && !this.paramsData.recharge_levels) {
        this.$message.error(this.$t('pleaseInputLevel'));
        return;
      }

      if (/，/.test(this.paramsData.recharge_levels)) {
        this.$message.error(this.$t('pleaseInputEnglishComma'));
        return;
      }

      this.reqLoading = true;
      var params = {
        dimension_kind: this.paramsData.dimension_kind,
        game_id: this.searchData.game_id,
        special_product_id: this.searchData.special_product_id,
        starttime: this.searchData.starttime,
        endtime: this.searchData.endtime,
        server_id: this.paramsData.server_id,
        recharge_levels: this.paramsData.recharge_levels,
        penetration: this.paramsData.penetration,
        ad_channel: this.searchData.ad_channel,
        ad_placement: this.searchData.ad_placement
      }; //判断是否有货币

      var searchCurrency = this.$store.state.d2admin.serchSelect.searchCurrency;
      var reqFn = searchCurrency.length ? rechargeProducPenetrationRateCurrency : rechargeProducPenetrationRate;
      reqFn(params).then(function (res) {
        if (res.code == 200 && res.data) {
          var data = res.data;
          var tier_config = res.tier_config || {};
          var product_id_arr = res.product_id_arr || {};
          _this2.dateOrderProductIdArr = res.date_order_product_id_arr || {}; // ========== 核心过滤逻辑 ==========
          // 1. 筛选有数据的日期（至少一个层级user_count>0）

          _this2.filterValidDates(data); // 2. 筛选有数据的层级（至少一个有效日期user_count>0）


          _this2.filterValidLevels(data, tier_config); // 3. 筛选有数据的购买次数（至少一个有效日期+层级total>0）


          _this2.filterValidPurchaseTimes(data); // ========== 初始化tableData - 只保留有数据的层级 ==========


          _this2.tableData = _this2.validLevels.map(function (level) {
            var _tier_config$level, _tier_config$level2;

            return {
              level: level,
              recharge_range: ((_tier_config$level = tier_config[level]) === null || _tier_config$level === void 0 ? void 0 : _tier_config$level.range) || '',
              label: ((_tier_config$level2 = tier_config[level]) === null || _tier_config$level2 === void 0 ? void 0 : _tier_config$level2.label) || ''
            };
          }); // ========== 处理表格表头 - 只保留有数据的列 ==========

          _this2.tableList = [{
            label: "",
            prop: "recharge_range",
            list: [{
              label: _this2.$t('payAmount'),
              prop: "recharge_range",
              level: "all",
              desc: _this2.$t('payAmountRangeDesc')
            }]
          }]; // 只遍历有数据的日期

          _this2.validDates.forEach(function (date) {
            var dateItem = {
              label: date,
              prop: date,
              list: []
            }; // ========== 修改点1：每个日期都添加付费人数列 ==========
            // 移除只给第一个日期添加的限制，所有有效日期都显示付费人数列

            dateItem.list.push({
              label: _this2.$t('payPeopleCount'),
              prop: "".concat(date, "-user_count"),
              level: "all"
            }); // 只遍历有数据的购买次数

            _this2.validPurchaseTimes.forEach(function (time) {
              var _this2$dateOrderProdu;

              // 获取当前日期+次数下需要展示的商品ID列表
              var showProductIds = ((_this2$dateOrderProdu = _this2.dateOrderProductIdArr[date]) === null || _this2$dateOrderProdu === void 0 ? void 0 : _this2$dateOrderProdu[time]) || []; // 过滤：只有有商品数据时才添加该次数列

              if (showProductIds.length === 0) return;
              var timesItem = {
                label: _this2.$t('timesLabel', {
                  time: time
                }),
                prop: time,
                level: "all",
                list: []
              }; // 添加商品总数列

              timesItem.list.push({
                label: _this2.$t('productTotalCount'),
                prop: "".concat(date, "-").concat(time, "-total")
              }); // 添加有数据的商品列

              showProductIds.forEach(function (productId) {
                if (product_id_arr[productId]) {
                  timesItem.list.push({
                    label: "".concat(productId, ",").concat(product_id_arr[productId]),
                    prop: "".concat(date, "-").concat(time, "-").concat(productId)
                  });
                }
              }); // 只有有子列时才添加

              if (timesItem.list.length > 0) {
                dateItem.list.push(timesItem);
              }
            }); // 只有有子列时才添加日期项


            if (dateItem.list.length > 0) {
              _this2.tableList.push(dateItem);
            }
          }); // ========== 填充表格数据 ==========


          _this2.fillTableData(data);
        }
      }).finally(function () {
        _this2.reqLoading = false;
      });
    },

    /**
     * 筛选有数据的日期
     * 规则：该日期下至少有一个层级的user_count > 0
     */
    filterValidDates: function filterValidDates(data) {
      this.validDates = [];

      for (var date in data) {
        var hasValidData = false;

        for (var level in data[date]) {
          var _data$date$level;

          if (((_data$date$level = data[date][level]) === null || _data$date$level === void 0 ? void 0 : _data$date$level.user_count) > 0) {
            hasValidData = true;
            break;
          }
        }

        if (hasValidData) {
          this.validDates.push(date);
        }
      } // 按日期排序


      this.validDates.sort(function (a, b) {
        return new Date(a) - new Date(b);
      });
    },

    /**
     * 筛选有数据的层级
     * 规则：该层级在至少一个有效日期内user_count > 0
     */
    filterValidLevels: function filterValidLevels(data, tier_config) {
      this.validLevels = [];
      var levelSet = new Set();
      this.validDates.forEach(function (date) {
        for (var level in data[date]) {
          var _data$date$level2;

          if (((_data$date$level2 = data[date][level]) === null || _data$date$level2 === void 0 ? void 0 : _data$date$level2.user_count) > 0 && tier_config[level]) {
            levelSet.add(level);
          }
        }
      }); // 转换为数组并按层级排序

      this.validLevels = Array.from(levelSet).sort(function (a, b) {
        var numA = parseInt(a.replace('level_', '')) || 0;
        var numB = parseInt(b.replace('level_', '')) || 0;
        return numA - numB;
      });
    },

    /**
     * 筛选有数据的购买次数
     * 规则：该次数下至少有一个有效日期+层级的total > 0
     */
    filterValidPurchaseTimes: function filterValidPurchaseTimes(data) {
      var _this3 = this;

      this.validPurchaseTimes = [];
      var timeSet = new Set();
      this.validDates.forEach(function (date) {
        var _iterator = _createForOfIteratorHelper(_this3.validLevels),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var _data$date, _data$date$level3;

            var level = _step.value;
            var purchaseStats = ((_data$date = data[date]) === null || _data$date === void 0 ? void 0 : (_data$date$level3 = _data$date[level]) === null || _data$date$level3 === void 0 ? void 0 : _data$date$level3.purchase_stats) || {};

            for (var time in purchaseStats) {
              var _purchaseStats$time;

              if (((_purchaseStats$time = purchaseStats[time]) === null || _purchaseStats$time === void 0 ? void 0 : _purchaseStats$time.total) > 0) {
                timeSet.add(time);
              }
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }); // 转换为数组并排序

      this.validPurchaseTimes = Array.from(timeSet).sort(function (a, b) {
        return a - b;
      });
    },

    /**
     * 填充表格数据
     */
    fillTableData: function fillTableData(data) {
      var _this4 = this;

      this.tableData.forEach(function (row) {
        var level = row.level;

        _this4.tableList.forEach(function (dateColumn) {
          var date = dateColumn.prop;
          if (date === "recharge_range") return; // 填充付费人数数据（每个日期都要填充）

          dateColumn.list.forEach(function (subColumn) {
            if (subColumn.label === "付费人数") {
              var _data$date2, _data$date2$level;

              row["".concat(date, "-user_count")] = ((_data$date2 = data[date]) === null || _data$date2 === void 0 ? void 0 : (_data$date2$level = _data$date2[level]) === null || _data$date2$level === void 0 ? void 0 : _data$date2$level.user_count) || 0;
            }
          }); // 填充购买次数数据

          _this4.validPurchaseTimes.forEach(function (time) {
            var _this4$dateOrderProdu, _data$date3, _data$date3$level, _data$date3$level$pur, _data$date3$level$pur2;

            var showProductIds = ((_this4$dateOrderProdu = _this4.dateOrderProductIdArr[date]) === null || _this4$dateOrderProdu === void 0 ? void 0 : _this4$dateOrderProdu[time]) || [];
            if (showProductIds.length === 0) return; // 填充商品总数

            var totalProp = "".concat(date, "-").concat(time, "-total");
            row[totalProp] = ((_data$date3 = data[date]) === null || _data$date3 === void 0 ? void 0 : (_data$date3$level = _data$date3[level]) === null || _data$date3$level === void 0 ? void 0 : (_data$date3$level$pur = _data$date3$level.purchase_stats) === null || _data$date3$level$pur === void 0 ? void 0 : (_data$date3$level$pur2 = _data$date3$level$pur[time]) === null || _data$date3$level$pur2 === void 0 ? void 0 : _data$date3$level$pur2.total) || 0; // 填充商品数据

            showProductIds.forEach(function (productId) {
              var _data$date4, _data$date4$level, _data$date4$level$pur, _data$date4$level$pur2, _data$date4$level$pur3;

              var productProp = "".concat(date, "-").concat(time, "-").concat(productId);
              var productData = (_data$date4 = data[date]) === null || _data$date4 === void 0 ? void 0 : (_data$date4$level = _data$date4[level]) === null || _data$date4$level === void 0 ? void 0 : (_data$date4$level$pur = _data$date4$level.purchase_stats) === null || _data$date4$level$pur === void 0 ? void 0 : (_data$date4$level$pur2 = _data$date4$level$pur[time]) === null || _data$date4$level$pur2 === void 0 ? void 0 : (_data$date4$level$pur3 = _data$date4$level$pur2.products) === null || _data$date4$level$pur3 === void 0 ? void 0 : _data$date4$level$pur3[productId];
              row[productProp] = productData || '0';
            });
          });
        });
      });
    },
    exportdata: function exportdata() {
      var _this5 = this;

      this.exportdataDealoading = true;

      try {
        // 1. 构建工作表数据
        var wsData = []; // 2. 构建四级表头（只包含有数据的列）

        var headerRow1 = [this.$t('payAmount')];
        var headerRow2 = [this.$t('amountRange')];
        var headerRow3 = [''];
        var headerRow4 = ['']; // ========== 修改点2：导出时每个日期都显示付费人数列 ==========
        // 移除isFirstDate的限制

        this.tableList.forEach(function (dateColumn) {
          if (dateColumn.prop === 'recharge_range') return;
          var dateLabel = dateColumn.label;
          var dateColumnCount = 0; // 计算当前日期列的总列数

          dateColumn.list.forEach(function (subColumn) {
            if (subColumn.label === _this5.$t('payPeopleCount')) {
              dateColumnCount += 1;
            } else if (subColumn.list) {
              dateColumnCount += subColumn.list.length;
            }
          }); // 第一行：日期（跨列）

          headerRow1.push(dateLabel);

          for (var i = 1; i < dateColumnCount; i++) {
            headerRow1.push('');
          } // 处理子列


          dateColumn.list.forEach(function (subColumn) {
            if (subColumn.label === _this5.$t('payPeopleCount')) {
              // 每个日期都显示付费人数列
              headerRow2.push(_this5.$t('payPeopleCount'));
              headerRow3.push("");
              headerRow4.push("");
            } else if (subColumn.list) {
              var timesLabel = subColumn.label;
              var columnCount = subColumn.list.length; // 第二行：次数（跨列）

              headerRow2.push(timesLabel);

              for (var _i = 1; _i < columnCount; _i++) {
                headerRow2.push('');
              } // 第三、四行：商品列


              subColumn.list.forEach(function (productColumn) {
                if (productColumn.label === _this5.$t('productTotalCount')) {
                  headerRow3.push(productColumn.label);
                  headerRow4.push('');
                } else {
                  var labelParts = productColumn.label.split(',');
                  headerRow3.push(labelParts[0] || '');
                  headerRow4.push(labelParts[1] || '');
                }
              });
            }
          });
        }); // 添加表头行

        wsData.push(headerRow1);
        wsData.push(headerRow2);
        wsData.push(headerRow3);
        wsData.push(headerRow4); // 3. 构建数据行（只包含有数据的行）

        this.tableData.forEach(function (row) {
          var rowData = [row.recharge_range || '']; // 填充有数据的列

          _this5.tableList.forEach(function (dateColumn) {
            if (dateColumn.prop === 'recharge_range') return;
            var date = dateColumn.prop; // ========== 修改点3：导出数据时每个日期都填充付费人数 ==========
            // 移除isFirstDateData的限制

            dateColumn.list.forEach(function (subColumn) {
              if (subColumn.label === _this5.$t('payPeopleCount')) {
                rowData.push(row["".concat(date, "-user_count")] || 0);
              } else if (subColumn.list) {
                var time = subColumn.prop;
                subColumn.list.forEach(function (productColumn) {
                  var prop;

                  if (productColumn.label === _this5.$t('productTotalCount')) {
                    prop = "".concat(date, "-").concat(time, "-total");
                  } else {
                    prop = "".concat(date, "-").concat(time, "-").concat(productColumn.label.split(',')[0]);
                  }

                  rowData.push(row[prop] || 0);
                });
              }
            });
          });

          wsData.push(rowData);
        }); // 4. 创建工作表

        var ws = XLSX.utils.aoa_to_sheet(wsData); // 5. 设置合并单元格

        var merges = [];
        merges.push({
          s: {
            r: 0,
            c: 0
          },
          e: {
            r: 3,
            c: 0
          }
        }); // 合并付费金额

        var colIndex = 1; // ========== 修改点4：合并单元格时每个日期都处理付费人数列 ==========
        // 移除isFirstDateMerge的限制

        this.tableList.forEach(function (dateColumn) {
          if (dateColumn.prop === 'recharge_range') return;
          var dateColumnCount = 0;
          dateColumn.list.forEach(function (subColumn) {
            if (subColumn.label === _this5.$t('payPeopleCount')) {
              dateColumnCount += 1;
            } else if (subColumn.list) {
              dateColumnCount += subColumn.list.length;
            }
          }); // 合并日期单元格

          if (dateColumnCount > 1) {
            merges.push({
              s: {
                r: 0,
                c: colIndex
              },
              e: {
                r: 0,
                c: colIndex + dateColumnCount - 1
              }
            });
          } // 处理子列合并


          dateColumn.list.forEach(function (subColumn) {
            if (subColumn.label === _this5.$t('payPeopleCount')) {
              // 每个日期的付费人数列都合并单元格
              merges.push({
                s: {
                  r: 1,
                  c: colIndex
                },
                e: {
                  r: 3,
                  c: colIndex
                }
              });
              colIndex++;
            } else if (subColumn.list) {
              var columnCount = subColumn.list.length; // 合并次数单元格

              if (columnCount > 1) {
                merges.push({
                  s: {
                    r: 1,
                    c: colIndex
                  },
                  e: {
                    r: 1,
                    c: colIndex + columnCount - 1
                  }
                });
              } // 处理商品列合并


              subColumn.list.forEach(function (productColumn, index) {
                var currentCol = colIndex + index;

                if (productColumn.label === _this5.$t('productTotalCount')) {
                  merges.push({
                    s: {
                      r: 2,
                      c: currentCol
                    },
                    e: {
                      r: 3,
                      c: currentCol
                    }
                  });
                }
              });
              colIndex += columnCount;
            }
          });
        });
        ws['!merges'] = merges; // 6. 设置列宽

        var colWidths = [{
          width: 15
        }];

        var _loop = function _loop(i) {
          var _headerRow2$i, _headerRow3$i, _headerRow4$i;

          var maxLength = Math.max.apply(Math, [((_headerRow2$i = headerRow2[i]) === null || _headerRow2$i === void 0 ? void 0 : _headerRow2$i.toString().length) || 0, ((_headerRow3$i = headerRow3[i]) === null || _headerRow3$i === void 0 ? void 0 : _headerRow3$i.toString().length) || 0, ((_headerRow4$i = headerRow4[i]) === null || _headerRow4$i === void 0 ? void 0 : _headerRow4$i.toString().length) || 0].concat(_toConsumableArray(wsData.slice(4).map(function (row) {
            return row[i] ? row[i].toString().length : 0;
          }))));
          colWidths.push({
            width: Math.min(Math.max(maxLength + 2, 8), 20)
          });
        };

        for (var i = 1; i < headerRow4.length; i++) {
          _loop(i);
        }

        ws['!cols'] = colWidths; // 7. 设置单元格样式

        var range = XLSX.utils.decode_range(ws['!ref'] || 'A1:A1'); // 表头样式

        for (var R = 0; R < 4; R++) {
          for (var C = range.s.c; C <= range.e.c; C++) {
            var cellAddress = XLSX.utils.encode_cell({
              r: R,
              c: C
            });
            if (!ws[cellAddress]) ws[cellAddress] = {
              t: 's',
              v: ''
            };
            ws[cellAddress].s = {
              font: {
                bold: true,
                sz: 10
              },
              alignment: {
                horizontal: 'center',
                vertical: 'center',
                wrapText: true
              },
              fill: {
                fgColor: {
                  rgb: "E6E6FA"
                }
              }
            };
          }
        } // 数据行样式


        for (var _R = 4; _R <= range.e.r; _R++) {
          for (var _C = range.s.c; _C <= range.e.c; _C++) {
            var _cellAddress = XLSX.utils.encode_cell({
              r: _R,
              c: _C
            });

            if (ws[_cellAddress] && !ws[_cellAddress].s) {
              ws[_cellAddress].s = {
                alignment: {
                  horizontal: 'center',
                  vertical: 'center'
                }
              };
            }
          }
        } // 8. 导出文件


        var wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, this.$t('paymentPenetrationRateSheet'));
        var fileName = "".concat(this.$t('productPenetrationRate'), ".xlsx");
        XLSX.writeFile(wb, fileName);
        this.$message.success(this.$t('exportSuccess'));
      } catch (error) {
        console.error('导出失败:', error);
        this.$message.error(this.$t('exportFailedRetry'));
      } finally {
        this.exportdataDealoading = false;
      }
    }
  }
};